import clsx from 'clsx'
import { ReactNode } from 'react'

/* blocks */
import Seo from '@/molecules/SEO/SEO'
import Index25Header from '@/cmp/molecules/Index25Header/Header'

/* utils */
import { inter } from '@/styles/fonts/fonts'

interface Meta {
  property: string
  content: string
}

interface Props {
  children: ReactNode
  title: string
  meta?: Meta[]
  canonical?: string
  jsonSchema?: LDJsonSchema[]
  noIndex?: boolean
}

function Layout({
  title,
  meta,
  children,
  canonical = '',
  jsonSchema,
  noIndex = false
}: Props) {
  return (
    <div className={clsx(inter.className, inter.variable)}>
      <Seo
        title={title}
        meta={meta}
        canonical={canonical}
        jsonSchema={jsonSchema}
        noIndex={noIndex}
      />
      <Index25Header />
      <main data-test-id="main">{children}</main>
    </div>
  )
}

export default Layout
